module.exports = __webpack_public_path__ + "img/test.45d68d9b.png";